import React, { FC, useState } from 'react'
import { useIntl } from 'react-intl'
import { toast } from 'react-toastify'
import { addMoreFilesPublicUrl } from '../../core/_requests'
import { useAuth } from '../../../auth'
import { FileUpload } from '../../../widgets/components/FileUpload'
import {
  addMoreFiles,
  uploadFileToDataRoomUploads,
  addFileInDrUploadsUrl,
} from '../../core/_requests'
import { BasicButton } from '../../../widgets/components/UI/BasicButton'
import { useMoveToFolderData } from '../../core/FileToFolderAuth'
import { toAbsoluteUrl } from '../../../../../_metronic/helpers'
import { errorMessage } from '../../../profile/core/_constants'
import TagManager from 'react-gtm-module'
import { GTMEvent } from '../../../../hooks/gtmHelpers'
import { ToolTipUIForModal } from '../../../widgets/components/UI/ToolTipUIForModal'

interface UploadOptionsDrawerProps {
  getBreadcrumb?: any
  uploadFileContentId?: any
  uploadOrAdd?: boolean
  setUploadOrAdd?: any
  getCompanyFolderChildren?: any
  companyFolderContentId?: any
  DrClick?: any
  dataRoomId?: any
}

export const UploadOptionsDrawer: FC<UploadOptionsDrawerProps> = ({
  getBreadcrumb,
  uploadFileContentId,
  uploadOrAdd,
  setUploadOrAdd,
  DrClick,
  dataRoomId,
  getCompanyFolderChildren,
  companyFolderContentId,
}) => {
  const { formatMessage } = useIntl()
  const { companyId, setShowBillingModal, currentUser } = useAuth()
  const [title, setTitle] = useState<string>('')
  const [url, setUrl] = useState<string>('')
  const {
    setShowDrawer,
    showOptionsDrawer,
    setShowOptionsDrawer,
    addUrlDrawer,
    setAddUrlDrawer,
    addUploadDrawer,
    setAddUploadDrawer,
    filesContentId,
    breadcrumbContentId,
    setShowAddContentDrawer,
    setRefreshFuncBoolDr,
  } = useMoveToFolderData()
  const [modelStatus, setModelStatus] = useState<boolean>(false)
  const [, setFileName] = useState<any>('')
  const [addingFile, setAddingFile] = useState<boolean>(false)
  const [uploadErr, setUploadErr] = useState<boolean>(false)
  const [urlErr, setUrlErr] = useState<boolean>(false)
  const [titleErr, setTitleErr] = useState<boolean>(false)
  const [fileID, setFileID] = useState<number>(0)
  const [storeFileIdsNew, setStoreFileIdsNew] = useState<any>([])
  const handleTitle = (event: React.ChangeEvent<HTMLInputElement>) => {
    setTitle(event.target.value)
    setTitleErr(false)
  }

  const handleUrl = (event: React.ChangeEvent<HTMLInputElement>) => {
    setUrl(event.target.value)
    setUrlErr(false)
  }
  const handleAddMoreFilesUrl = async (
    name: string,
    url: string,
    parentId: string,
    companyId: number
  ) => {
    if (!name) {
      setTitleErr(true)
      return
    }
    if (!url) {
      setUrlErr(true)
      return
    }
    try {
      setAddingFile(true)
      if (companyId) {
        const {
          data: { success, errors },
        } = await addMoreFilesPublicUrl(name, url, parentId, companyId)
        if (success) {
          setShowDrawer(false)
          setShowOptionsDrawer(false)
          setAddUrlDrawer(false)
          setAddUploadDrawer(false)
          setShowAddContentDrawer(false)
          toast.success(formatMessage({ id: 'File added successfully' }))
          setTitle('')
          setUrl('')
          setUploadOrAdd(false)
          if (getBreadcrumb) {
            if (companyFolderContentId === breadcrumbContentId) {
              getCompanyFolderChildren(breadcrumbContentId)
            } else {
              getBreadcrumb(breadcrumbContentId)
            }
          }
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.AddMoreFilesToPublicUrlSuccessful,
              action: 'normal',
              metadata: {
                file_name: name,
                file_url: url,
                parent_id: parentId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                company_id: companyId,
              },
            },
          })
        } else {
          errors.forEach((error: string) => {
            toast.error(formatMessage({ id: error }))
          })
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.AddMoreFilesToPublicUrlFailed,
              action: 'normal',
              metadata: {
                file_name: name,
                file_url: url,
                parent_id: parentId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                company_id: companyId,
                error: errors[0],
              },
            },
          })
          setShowDrawer(false)
          setShowOptionsDrawer(false)
          setAddUrlDrawer(false)
          setAddUploadDrawer(false)
          setUploadOrAdd(false)
          setShowAddContentDrawer(false)
        }
      }
    } catch (err) {
      console.log(err)
    } finally {
      setAddingFile(false)
    }
  }

  const handleOpen = () => {
    setModelStatus(true)
  }
  const handleClose = () => {
    setModelStatus(false)
  }

  const handleAddMoreFiles = async (
    type: string,
    companyId: number,
    name: string,
    fileID: number,
    filesContentId: string
  ) => {
    if (!name) {
      return
    }
    if (!fileID) {
      setUploadErr(true)
      return
    }
    setUploadErr(false)
    try {
      setAddingFile(true)
      if (companyId) {
        const {
          data: { success, errors },
        } = await addMoreFiles(type, companyId, name, fileID, filesContentId)
        if (success) {
          setShowDrawer(false)
          setShowOptionsDrawer(false)
          setAddUrlDrawer(false)
          setAddUploadDrawer(false)
          setShowAddContentDrawer(false)
          toast.success(formatMessage({ id: 'File added successfully' }))
          setFileName('')
          setUploadOrAdd(false)
          setStoreFileIdsNew([])
          setFileID(0)
          if (getBreadcrumb) {
            if (companyFolderContentId === breadcrumbContentId) {
              getCompanyFolderChildren(breadcrumbContentId)
            } else {
              getBreadcrumb(breadcrumbContentId)
            }
          }
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.DataRoomAddMoreFilesContentSuccessful,
              action: 'normal',
              metadata: {
                file_type: type,
                file_name: name,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                company_id: companyId,
                file_id: fileID,
                files_content_id: filesContentId,
              },
            },
          })
        } else {
          // errors.forEach((error: string) => {
          //   toast.error(formatMessage({id: error}))
          // })
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.DataRoomAddMoreFilesContentFailed,
              action: 'normal',
              metadata: {
                file_type: type,
                file_name: name,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                company_id: companyId,
                file_id: fileID,
                files_content_id: filesContentId,
                error: errors[0],
              },
            },
          })
          setShowDrawer(false)
          setShowOptionsDrawer(false)
          setAddUrlDrawer(false)
          setAddUploadDrawer(false)
          setUploadOrAdd(false)
          setShowAddContentDrawer(false)
          setStoreFileIdsNew([])
          setShowBillingModal(true)
          errors.forEach((error: string) => {
            toast.error(formatMessage({ id: error }), { autoClose: false })
          })
        }
      }
    } catch (err) {
      console.log(err)
    } finally {
      setAddingFile(false)
    }
  }

  const handleRemoveClickNew = (id: string) => {
    const updatedFileIds = storeFileIdsNew.filter((file: any) => file.id !== id)
    setStoreFileIdsNew(updatedFileIds)
  }

  const handleAddFilesToDRUploads = async (
    name: string,
    type: string,
    fileId: number,
    dataRoomId: number
  ) => {
    if (!name) {
      return
    }
    if (!fileID) {
      setUploadErr(true)
      return
    }
    setUploadErr(false)
    try {
      setAddingFile(true)
      if (companyId) {
        const {
          data: { success, errors },
        } = await uploadFileToDataRoomUploads(name, type, fileId, dataRoomId)
        if (success) {
          setShowDrawer(false)
          setShowOptionsDrawer(false)
          setAddUrlDrawer(false)
          setAddUploadDrawer(false)
          setRefreshFuncBoolDr(true)
          toast.success(formatMessage({ id: 'File added successfully' }))
          setFileName('')
          // setUploadOrAdd(false)
          setStoreFileIdsNew([])
          setFileID(0)
          if (getBreadcrumb) {
            if (companyFolderContentId === breadcrumbContentId) {
              getCompanyFolderChildren(breadcrumbContentId)
            } else {
              getBreadcrumb(breadcrumbContentId)
            }
          }
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.UploadFileToDataRoomSuccessful,
              action: 'normal',
              metadata: {
                file_type: type,
                file_name: name,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                company_id: companyId,
                file_id: fileID,
                data_room_id: dataRoomId,
              },
            },
          })
        } else {
          // errors.forEach((error: string) => {
          //   toast.error(formatMessage({id: error}))
          // })
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.UploadFileToDataRoomFailed,
              action: 'normal',
              metadata: {
                file_type: type,
                file_name: name,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                company_id: companyId,
                file_id: fileID,
                data_room_id: dataRoomId,
                error: errors[0],
              },
            },
          })
          setShowDrawer(false)
          setShowOptionsDrawer(false)
          setAddUrlDrawer(false)
          setAddUploadDrawer(false)
          setUploadOrAdd(false)
          setStoreFileIdsNew([])
          setShowBillingModal(true)
          errors.forEach((error: string) => {
            toast.error(formatMessage({ id: error }), { autoClose: false })
          })
        }
      }
    } catch (err) {
      console.log(err)
    } finally {
      setAddingFile(false)
    }
  }

  const handleAddFilesToDRUrl = async (name: string, URL: string, dataRoomUpload: boolean) => {
    if (!name) {
      setTitleErr(true)
      return
    }
    if (!url) {
      setUrlErr(true)
      return
    }
    try {
      setAddingFile(true)
      if (companyId) {
        const {
          data: { success, errors },
        } = await addFileInDrUploadsUrl(name, URL, dataRoomUpload)
        if (success) {
          setShowDrawer(false)
          setShowOptionsDrawer(false)
          setAddUrlDrawer(false)
          setAddUploadDrawer(false)
          setRefreshFuncBoolDr(true)
          toast.success(formatMessage({ id: 'File added successfully' }))
          setTitle('')
          setUrl('')
          setUploadOrAdd(false)
          if (getBreadcrumb) {
            if (companyFolderContentId === breadcrumbContentId) {
              getCompanyFolderChildren(breadcrumbContentId)
            } else {
              getBreadcrumb(breadcrumbContentId)
            }
          }
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.UploadFileToDataRoomUploadsUrlSuccessful,
              action: 'normal',
              metadata: {
                file_name: name,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                company_id: companyId,
                url: URL,
              },
            },
          })
        } else {
          // errors.forEach((error: string) => {
          //   toast.error(formatMessage({id: error}))
          // })
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.UploadFileToDataRoomUploadsUrlFailed,
              action: 'normal',
              metadata: {
                file_name: name,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                company_id: companyId,
                url: URL,
                error: errors[0],
              },
            },
          })
          setShowDrawer(false)
          setShowOptionsDrawer(false)
          setAddUrlDrawer(false)
          setAddUploadDrawer(false)
          setUploadOrAdd(false)
          setStoreFileIdsNew([])
          errors.forEach((error: string) => {
            if (
              error === errorMessage.UPGRADE_BILLING_PLAN_LIMIT_EXCEEDED ||
              error === errorMessage.UPGRADE_BILLING_PLAN_FEATURE
            ) {
              setShowBillingModal(true)
              toast.error(formatMessage({ id: error }), { autoClose: false })
            } else {
              toast.error(formatMessage({ id: error }))
            }
          })
        }
      }
    } catch (err) {
      console.log(err)
    } finally {
      setAddingFile(false)
    }
  }

  return (
    <div
      id='kt_upload_options'
      className={`${showOptionsDrawer ? 'bg-body drawer drawer-end drawer-on' : 'bg-body drawer drawer-end'
        }`}
      data-kt-drawer='true'
      data-kt-drawer-name='activities'
      data-kt-drawer-activate='true'
      data-kt-drawer-overlay='true'
      data-kt-drawer-width="{default:'312px', 'md': '660px'}"
      data-kt-drawer-direction='end'
      data-kt-drawer-toggle='#kt_upload_options_toggle'
      data-kt-drawer-close='#kt_upload_options_close'
    >
      <div className='upload-options-drawer-wrapper card shadow-none rounded-0 w-100'>
        <div
          className='drawer-header d-flex flex-row align-items-center justify-content-between flex-wrap  '
          id='kt_upload_options_header'
        >
          <div className='d-flex flex-row align-items-center  '>
            <button
              type='button'
              className='btn p-0 btn-active-light-primary me-4 '
              onClick={() => {
                setShowOptionsDrawer(false)
                setAddUrlDrawer(false)
                setAddUploadDrawer(false)
                setUrl('')
                setTitle('')
                setFileName('')
              }}
            ></button>

            <div className='d-flex flex-row align-items-center '>
              <h3 className='drawer-head-title  mb-0 me-4 text-dark'>
                {addUploadDrawer
                  ? formatMessage({ id: 'Upload Files' })
                  : formatMessage({ id: 'Add URL' })}
              </h3>
              <ToolTipUIForModal
                tooltipText={
                  addUploadDrawer
                    ? formatMessage({
                      id: 'Please upload the file.',
                    })
                    : formatMessage({
                      id: 'Please enter the public URL of the file.',
                    })
                }
              />
            </div>
          </div>
        </div>
        <div
          className='upload-options-drawer-body px-5 py-4 p-md-7 position-relative'
          id='kt_upload_options_body'
        >
          <div
            id='kt_upload_options_scroll'
            className='w-100 d-flex flex-column  h-auto mt-2 activity-container-n overflow-visible'
            data-kt-scroll='true'
            data-kt-scroll-height='auto'
            data-kt-scroll-wrappers='#kt_upload_options_body'
            data-kt-scroll-dependencies='#kt_upload_options_header, #kt_upload_options_footer'
            data-kt-scroll-offset='5px'
          >
            <ul className='nav nav-pills mb-3 ' id='pills-tab' role='tablist'>
              <li className='nav-item me-7' role='presentation'>
                <button
                  className={`${addUploadDrawer ? 'nav-link active' : 'nav-link'}`}
                  id='pills-upload-files-tab'
                  type='button'
                  role='tab'
                  aria-selected={addUploadDrawer ? false : true}
                  onClick={() => {
                    setAddUploadDrawer(true)
                    setAddUrlDrawer(false)
                  }}
                >
                  {formatMessage({ id: 'Upload Files' })}
                </button>
              </li>
              <li className='nav-item' role='presentation'>
                <button
                  className={`${addUrlDrawer ? 'nav-link active' : 'nav-link'}`}
                  id='pills-add-link-tab'
                  type='button'
                  role='tab'
                  aria-selected={addUrlDrawer ? true : false}
                  onClick={() => {
                    setAddUrlDrawer(true)
                    setAddUploadDrawer(false)
                  }}
                >
                  {formatMessage({ id: 'Add URL' })}
                </button>
              </li>
            </ul>
            <div className='tab-content' id='pills-Url-tabContent'>
              <div
                className={`${addUploadDrawer ? 'tab-pane fade active show' : 'tab-pane fade'}`}
                role='tabpanel'
                aria-labelledby='pills-upload-files-tab'
              >
                <div className='drop-file-box mt-9'>
                  <div className=' mt-5' onClick={handleOpen}>
                    <button className=' d-flex align-items-center justify-content-center btn btn-bg-secondary font-size-13 text-dark font-weight-400 height-36 w-100 w-md-auto'>
                      {formatMessage({ id: 'Upload File' })}
                    </button>
                  </div>
                  <FileUpload
                    fileSize={2097152}
                    maxFileNumber={Number(process.env.MAX_FILE_NUMBER) || 100}
                    allowType={[
                      'image/*',
                      '.jpg',
                      '.jpeg',
                      '.png',
                      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                      'application/pdf',
                      'application/msword',
                      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                      'application/vnd.openxmlformats-officedocument.presentationml.presentation',
                      'application/vnd.ms-powerpoint',
                    ]}
                    metaData={{
                      module: 'doc+img',
                      isProtected: false,
                      companyId: companyId,
                    }}
                    modalStatus={modelStatus}
                    handleClose={handleClose}
                    handleSuccess={(id: number, name: string) => {
                      setFileID(id)
                      const fileNameOriginal = name
                      const lastIndex = fileNameOriginal.lastIndexOf('.')
                      let extension
                      if (lastIndex !== -1) {
                        extension = fileNameOriginal.slice(0, lastIndex)
                      }
                      setFileName(extension)
                      const newFile = { id, name }
                      setStoreFileIdsNew((prevIds?: any) => [...prevIds, newFile])
                    }}
                    showCompatibilityMsg={false}
                    resourceType='all'
                  />
                  {uploadErr && (
                    <p className='text-danger'>
                      {formatMessage({ id: 'Error : Please upload a file' })}
                    </p>
                  )}
                </div>
                {storeFileIdsNew?.length > 0 &&
                  storeFileIdsNew?.map((file: any) => (
                    <div key={file?.id} className='d-flex mt-3 gap-3 align-items-center'>
                      <div className='d-flex gap-0 align-items-center'>
                        <div>
                          {file && file?.name.split('.').pop() === 'pdf' && (
                            <img
                              height={35}
                              width={35}
                              alt='pdf'
                              className='pe-2'
                              src={toAbsoluteUrl(`/media/icons/file_extensions/${file?.name.split('.').pop()}.svg`)}
                            />
                          )}
                          {file &&
                            (file?.name.split('.').pop() === 'docx' ||
                              file?.name.split('.').pop() === 'doc') && (
                              <img
                                height={35}
                                width={37}
                                alt='docx'
                                className='pe-2'
                                src={toAbsoluteUrl(`/media/icons/file_extensions/${file?.name.split('.').pop()}.svg`)}
                              />
                            )}
                          {file &&
                            (file?.name.split('.').pop() === 'pptx' ||
                              file?.name.split('.').pop() === 'ppt') && (
                              <img
                                height={35}
                                width={37}
                                alt='pptx'
                                className='pe-2'
                                src={toAbsoluteUrl(`/media/icons/file_extensions/${file?.name.split('.').pop()}.svg`)}
                              />
                            )}
                          {file &&
                            (file?.name.split('.').pop() === 'jpg' ||
                              file?.name.split('.').pop() === 'png' ||
                              file?.name.split('.').pop() === 'jpeg') && (
                              <img
                                height={27}
                                width={27}
                                alt='blank'
                                className='pe-2'
                                src={toAbsoluteUrl(`/media/icons/file_extensions/${file?.name.split('.').pop()}.svg`)}
                              />
                            )}
                          {file && file?.name.split('.').pop() === 'xlsx' && (
                            <img
                              height={33}
                              width={33}
                              alt='blank'
                              className='pe-2'
                              src={toAbsoluteUrl(`/media/icons/file_extensions/${file?.name.split('.').pop()}.svg`)}
                            />
                          )}
                          {file &&
                            !(
                              file?.name.split('.').pop() === 'pdf' ||
                              file?.name.split('.').pop() === 'docx' ||
                              file?.name.split('.').pop() === 'doc' ||
                              file?.name.split('.').pop() === 'pptx' ||
                              file?.name.split('.').pop() === 'ppt' ||
                              file?.name.split('.').pop() === 'jpg' ||
                              file?.name.split('.').pop() === 'png' ||
                              file?.name.split('.').pop() === 'jpeg' ||
                              file?.name.split('.').pop() === 'xlsx'
                            ) && (
                              <img
                                height={27}
                                width={27}
                                alt='blank'
                                className='pe-2'
                                src={toAbsoluteUrl(`/media/icons/file_extensions/${file?.name.split('.').pop()}.svg`)}
                              />
                            )}
                        </div>
                        <p className='m-0'>{`${file?.name.split('/').pop().substring(0, 25)}${file?.name.split('/').pop().length > 25 ? '...' : ''
                          }`}</p>
                      </div>
                      <img
                        onClick={() => handleRemoveClickNew(file?.id)}
                        src={toAbsoluteUrl('/media/icons/investor-updates/deleteRed.svg')}
                        alt='garbage icon'
                        className='cursor-pointer'
                      />
                    </div>
                  ))}
                <div className='drawer-footer d-flex flex-md-row flex-column w-100 gap-2' id='kt_footer'>
                  <BasicButton
                    height='52px'
                    border='none'
                    color='#4776E6'
                    textColor='white'
                    padding='12px 16px'
                    onClick={() => {
                      if (DrClick) {
                        storeFileIdsNew.forEach((file: { id: number; name: string }) => {
                          const lastIndex = file.name.lastIndexOf('.')
                          let fileName = ''
                          if (lastIndex !== -1) {
                            fileName = file.name.slice(0, lastIndex)
                          }
                          handleAddFilesToDRUploads(fileName, 'FILE', file.id, dataRoomId)
                        })
                      } else {
                        if (uploadOrAdd) {
                          storeFileIdsNew.forEach((file: { id: number; name: string }) => {
                            const lastIndex = file.name.lastIndexOf('.')
                            let fileName = ''
                            if (lastIndex !== -1) {
                              fileName = file.name.slice(0, lastIndex)
                            }
                            handleAddMoreFiles(
                              'FILE',
                              +companyId!,
                              fileName,
                              file.id,
                              uploadFileContentId
                            )
                          })
                        } else {
                          storeFileIdsNew.forEach((file: { id: number; name: string }) => {
                            const lastIndex = file.name.lastIndexOf('.')
                            let fileName = ''
                            if (lastIndex !== -1) {
                              fileName = file.name.slice(0, lastIndex)
                            }
                            handleAddMoreFiles(
                              'FILE',
                              +companyId!,
                              fileName,
                              file.id,
                              filesContentId
                            )
                          })
                        }
                      }
                    }}
                    buttonText={formatMessage({ id: 'Save Changes' })}
                    minWidth={56}
                    loading={addingFile}
                  />
                  <button
                    id='kt_upload_options_close'
                    className='btn bg-light text-muted flex-grow-1 flex-md-grow-0  custom-button-property'
                    onClick={() => {
                      setFileName('')
                      setShowOptionsDrawer(false)
                      setAddUrlDrawer(false)
                      setAddUploadDrawer(false)
                      setUrl('')
                      setTitle('')
                      setFileName('')
                      setUploadOrAdd(false)
                      setStoreFileIdsNew([])
                    }}
                  >
                    {formatMessage({ id: 'Cancel' })}
                  </button>
                </div>
              </div>
              <div
                className={`${addUrlDrawer ? 'tab-pane fade active show' : 'tab-pane fade'}`}
                role='tabpanel'
                aria-labelledby='pills-add-link-tab'
              >
                <form>
                  <div className='my-7'>
                    <label htmlFor='uploadLinkTitle' className='form-label'>
                      {formatMessage({ id: 'Title' })}
                    </label>
                    <input
                      type='text'
                      className={`${titleErr ? 'form-control border border-danger' : 'form-control'
                        }`}
                      id='uploadLinkTitle'
                      placeholder={formatMessage({ id: 'Enter Title' })}
                      value={title}
                      onChange={handleTitle}
                    />
                    {titleErr && (
                      <p className='text-danger'>
                        {formatMessage({ id: 'Error : Enter the file name' })}
                      </p>
                    )}
                  </div>
                  <div className='mb-3'>
                    <label htmlFor='uploadLink' className='form-label'>
                      {formatMessage({ id: 'Link' })}
                    </label>
                    <input
                      type='text'
                      className={`${urlErr ? 'form-control border border-danger' : 'form-control'}`}
                      id='uploadLink'
                      placeholder={formatMessage({ id: 'Enter Link' })}
                      value={url}
                      onChange={handleUrl}
                    />
                    {urlErr && (
                      <p className='text-danger'>{formatMessage({ id: 'Error : Enter the url' })} </p>
                    )}
                  </div>
                  <div className='drawer-footer d-flex flex-md-row flex-column w-100 gap-2' id='kt_footer'>
                    <BasicButton
                      height='52px'
                      border='none'
                      color='#4776E6'
                      textColor='white'
                      padding='12px 16px'
                      onClick={() => {
                        if (DrClick) {
                          handleAddFilesToDRUrl(title, url, true)
                        } else {
                          if (uploadOrAdd) {
                            handleAddMoreFilesUrl(title, url, uploadFileContentId, +companyId!)
                          } else {
                            handleAddMoreFilesUrl(title, url, filesContentId, +companyId!)
                          }
                        }
                      }}
                      buttonText='Save Changes'
                      minWidth={56}
                      loading={addingFile}
                    />
                    <button
                      id='kt_upload_options_close'
                      className='btn bg-light text-muted flex-grow-1 flex-md-grow-0 custom-button-property'
                      onClick={() => {
                        setTitle('')
                        setUrl('')
                        setShowOptionsDrawer(false)
                        setAddUrlDrawer(false)
                        setAddUploadDrawer(false)
                        setUrl('')
                        setTitle('')
                        setFileName('')
                        setUploadOrAdd(false)
                      }}
                    >
                      {formatMessage({ id: 'Cancel' })}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
